/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  list: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
  combo: null,
};

const actions = {
  getList({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/combo?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detail({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/combo/${id}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create shift
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("combo", payload)
        .then((response) => {
          commit("CREATE_SUCCESS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * delete multiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/combo/${id}`)
        .then((response) => {
          commit("UPDATE_SUCCESS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete shift
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`combo/${id}`);
  },

  /**
   * set current page
   * @param commit
   * @param page
   */
  setCurrentPage({ commit }, page) {
    commit("SET_CURRENT_PAGE", page);
  },

  /**
   * set per page
   * @param commit
   * @param size
   */
  setPerPage({ commit }, size) {
    commit("SET_PER_PAGE", size);
  },
};

const mutations = {
  SET_LIST(state, data) {
    state.list = data.items;
    state.pagination = data.pagination;
  },
  SET_DETAIL(state, combo) {
    state.combo = combo;
  },
  SET_CURRENT_PAGE(state, page) {
    state.pagination.current_page = page;
  },
  SET_PER_PAGE(state, size) {
    state.pagination.per_page = size;
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const index = state.list.findIndex((u) => u.id === item);
        state.list.splice(index, 1);
      });
    } else {
      const index = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(index, 1);
    }
  },
  CREATE_SUCCESS(state, data) {
    state.list.unshift(data);
  },
  UPDATE_SUCCESS(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.list.splice(pos, 1, data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
